import React, { FC, ReactNode } from 'react';
import { IconBackground } from 'common/components/IconBackground';
import { EColor } from 'common/const/color.enum';

interface IComponentProps {
  icon: ReactNode;
  name: string;
  color?: EColor;
  ellipsis?: boolean;
}

export const Label: FC<IComponentProps> = ({ icon, name, color, ellipsis }) => {
  return (
    <div className={`label ${color} ${ellipsis ? 'ellipsis' : ''}`} title={name}>
      <IconBackground content={icon} color={color} />

      <div className={`text-h4-item-name label__name ${ellipsis ? 'ellipsis' : ''}`}>{name}</div>
    </div>
  );
};
